<div class="impact-details_container">
  @if (isLoading) {
  <span class="impact-details_culture-name loading"></span>
  <div class="impact-details-arrowIcon-container loading">
    <div class="impact-details-loadingStateIcon"></div>
  </div>
  }@else{
  <div class="impact-details-name-icon-tag-tooltip-container">
    <div class="impact-details-name-icon-container">
      <mat-icon class="impact-details-culture-icon">{{ iconName }}</mat-icon>
      <span class="impact-details_culture-name">{{ familyName }}</span>
    </div>
    <div class="impact-details-tag-tooltip-container">
      <app-culture-impact-tag [impact]="impact"></app-culture-impact-tag>
      <app-claro-tooltip-icon
        [translatedTooltipText]="'stateView.tooltipTexts.cultureImpact' | translate"
      ></app-claro-tooltip-icon>
    </div>
  </div>
  <span class="material-symbols-outlined">{{ "stateView.cultureCardArrowIcon" | translate }}</span>
  }
</div>
